"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;
var _react = _interopRequireWildcard(require("react"));
var RadixAccordion = _interopRequireWildcard(require("@radix-ui/react-accordion"));
var _Icons = require("../Icons");
var _AccordionModule = _interopRequireDefault(require("./Accordion.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Accordion = _ref => {
  var items = _ref.items,
    _ref$contrast = _ref.contrast,
    contrast = _ref$contrast === void 0 ? 'high' : _ref$contrast;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    focusState = _useState2[0],
    setFocusState = _useState2[1];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _AccordionModule.default.Accordion,
    "data-contrast": contrast
  }, /*#__PURE__*/_react.default.createElement(RadixAccordion.Root, {
    className: _AccordionModule.default.Root,
    type: "single",
    collapsible: true
  }, items.map((itm, i) => /*#__PURE__*/_react.default.createElement(RadixAccordion.Item, {
    className: _AccordionModule.default.Item,
    value: "item-".concat(i),
    key: "".concat(itm.title, "-").concat(i),
    "data-focus-on-key-press": focusState
  }, /*#__PURE__*/_react.default.createElement(RadixAccordion.Header, {
    className: _AccordionModule.default.Header
  }, /*#__PURE__*/_react.default.createElement(RadixAccordion.Trigger, {
    className: _AccordionModule.default.Trigger,
    onMouseDown: () => setFocusState(false),
    onKeyDown: () => setFocusState(true)
  }, itm.title, /*#__PURE__*/_react.default.createElement(_Icons.IconChevronDown, {
    className: _AccordionModule.default.Chevron,
    isFilled: true,
    "aria-hidden": true,
    size: 16
  }))), /*#__PURE__*/_react.default.createElement(RadixAccordion.Content, {
    className: _AccordionModule.default.Content
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _AccordionModule.default.ContentText
  }, itm.content))))));
};
exports.Accordion = Accordion;
//# sourceMappingURL=Accordion.js.map